import React, { useState, useRef, useEffect } from "react"
import { SwitchTransition, CSSTransition } from "react-transition-group"
import lottie from 'lottie-web'
import loaderAnimData from "../images/lottie/loader.json"
import { GlobalEventBus } from '../helpers/eventBus'

const timeoutExit = 1000
const timeoutEnter = 500

const Transition = ({ children, location }) => {

	const [isTransitioning, setIsTransitioning] = useState(false)

	const handleExit = () => {
		setIsTransitioning(true)
		setTimeout(() => {
			window.scrollTo(0, 0)
		}, timeoutExit)
	}

	const handleEnter = () => {
		setIsTransitioning(false)
		GlobalEventBus.emit('onPageEnter')
	}

	// Lottie animation
	const animContainerEl = useRef(null)
	const lottieAnim = useRef(null)

	useEffect(() => {
		if (isTransitioning === true) {
			lottieAnim.current = lottie.loadAnimation({
				container: animContainerEl.current,
				renderer: 'svg',
				loop: true,
				autoplay: true,
				animationData: loaderAnimData
			})
		}
		return function clear () {
			if (lottieAnim.current) {
				lottieAnim.current.destroy();
			}
		}
	}, [isTransitioning])

	return (
		<>
			<SwitchTransition mode="out-in">
				<CSSTransition
					key={location.pathname}
					timeout={{
						exit: timeoutExit,
						enter: timeoutEnter
					}}
					onExit={handleExit}
					onEnter={handleEnter}
				>
					{children}
				</CSSTransition>
			</SwitchTransition>
			<div className={`Transition ${isTransitioning ? 'isVisible' : ''}`}>
				<div className="Transition__Side Transition__Left"></div>
				<div className="Transition__Side Transition__Right"></div>
				<div className="Transition__Side Transition__Top"></div>
				<div className="Transition__Side Transition__Bottom"></div>
				<div className="Transition__Animation" ref={animContainerEl}></div>
			</div>
		</>
	)

}
export default Transition